import "./StatTile.css";
import React from "react";

export type StatTileSize = "xs" | "sm" | "md" | "lg";
export type StatTileVariant = "normal" | "warning" | "danger" | "page";

export interface IStatTileProps {
    label: string;
    value: number | string;
    bonus?: number | string;
    size?: StatTileSize;
    variant?: StatTileVariant;
    showBonusBadge?: boolean;
    showValueRing?: boolean;
    className?: string;
}

function formatBonus(bonus: number | string | undefined): string | null {
    if (bonus === undefined || bonus === null) {
        return null;
    }

    if (typeof bonus === "number") {
        return bonus >= 0 ? `+${bonus}` : `${bonus}`;
    }

    const trimmed = bonus.trim();
    return trimmed.length > 0 ? trimmed : null;
}

export function StatTile(props: IStatTileProps): JSX.Element {
    const size: StatTileSize = props.size ?? "md";
    const variant: StatTileVariant = props.variant ?? "normal";
    const showValueRing = props.showValueRing === true;
    const showBonusBadge = props.showBonusBadge !== false;
    const bonusText = formatBonus(props.bonus);

    const classes = [
        "statTile",
        `statTile--${size}`,
        `statTile--${variant}`,
        showBonusBadge && bonusText ? "" : "statTile--noBadge",
        props.className ?? "",
    ].filter(Boolean).join(" ");

    return (
        <div className={classes}>
            <div className="statTile__label">{props.label.toUpperCase()}</div>

            {/* <div className="statTile__value">{props.value}</div> */}
            <div className={`statTile__value ${showValueRing ? "statTile__value--ring" : ""}`}>
                <span className="statTile__valueInner">{props.value}</span>
            </div>

            {showBonusBadge && bonusText ? (
                <div className="statTile__badge" aria-label={`Bonus ${bonusText}`}>
                    {bonusText}
                </div>
            ) : null}
        </div>
    );
}
